import { render, staticRenderFns } from "./ScreenMain.vue?vue&type=template&id=270528d4&scoped=true"
import script from "./ScreenMain.vue?vue&type=script&lang=js"
export * from "./ScreenMain.vue?vue&type=script&lang=js"
import style0 from "./ScreenMain.vue?vue&type=style&index=0&id=270528d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270528d4",
  null
  
)

export default component.exports